import React from 'react';
import css from './ResultLocationGroup.module.css';
import {
  ButtonType,
  Image,
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
  StackedRow,
  StackedRowSpacing,
  TextButton,
  WrappingContainer,
  WrappingContainerSpacing,
} from '../../../../../../../core';
import {
  CernerSlot,
  LocationGroup,
  SlotLocationAddress,
} from '../../../../../../../api/models';
import { MapPinDarkImage } from '../../../../../../../core/assets/images';
import { DateUtility } from '@mchs/web-core';

export interface ResultLocationGroupProps {
  locationGroup: LocationGroup;
  onSlotSelected: (
    slot: CernerSlot,
    locationId?: string,
    locationName?: string
  ) => void;
}

const formatAddress = (address?: SlotLocationAddress): string => {
  if (address === undefined) {
    return '';
  }
  return `${address.street1}, ${address.city}, ${address.state} ${address.zip}`;
};

const ResultLocationGroup: React.FC<ResultLocationGroupProps> = (
  props: ResultLocationGroupProps
) => {
  const onSlotClicked = (slot: CernerSlot) => {
    props.onSlotSelected(
      slot,
      props.locationGroup.locationId,
      props.locationGroup.locationName
    );
  };

  return (
    <StackedRow spacing={StackedRowSpacing.NoGap}>
      <Image
        source={MapPinDarkImage}
        alternateText="Location"
        width={14}
        height={17}
      />
      <div className={css.locationDetailContainer}>
        <StackedColumn spacing={StackedColumnSpacing.Tight}>
          <StackedColumn spacing={StackedColumnSpacing.NoGap}>
            <Paragraph text={props.locationGroup.locationName ?? ''} />
            <Paragraph
              text={formatAddress(props.locationGroup.locationAddress)}
              small={true}
            />
            <Paragraph text={props.locationGroup.timeZone ?? ''} small={true} />
          </StackedColumn>
          <WrappingContainer spacing={WrappingContainerSpacing.Tight}>
            <>
              {props.locationGroup.slotList
                ? props.locationGroup.slotList.map((slot) => (
                    <div key={slot.slotId} className={css.timeButtonContainer}>
                      <TextButton
                        caption={
                          slot.appointmentDateTime
                            ? DateUtility.formatTime(slot.appointmentDateTime)
                            : ''
                        }
                        onClick={() => onSlotClicked(slot)}
                        buttonType={ButtonType.Secondary}
                      />
                    </div>
                  ))
                : null}
            </>
          </WrappingContainer>
        </StackedColumn>
      </div>
    </StackedRow>
  );
};

export default ResultLocationGroup;
